// @flow
import JQueryView from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class FormView extends JQueryView {
  searchAddress: Object;

  constructor() {
    super('.simple_form');

    this.render();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        startDate: dayjs(),
        locale: {
          format: 'Y/MM/DD HH:mm',
        },
      },
      {
        picker: {
          format: {
            start: 'Y/MM/DD HH:mm',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  render() {
    this.initDateRangePicker(this.$el);
  }
}
